import SAVE_USER_WITH_DATATRUST from './saveUserWithDatatrust.gql';

export { SAVE_USER_WITH_DATATRUST };
